var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip"},[_vm._t("default",function(){return [_vm._v("! empty slot !")]}),_c('span',{staticClass:"tooltip__text",class:_vm.customClass},[_vm._v(_vm._s(_vm.message))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }